var fontlist = ['Rigid','Industry','Black Ops','Freckle Face','Geo','Germania','Tektur','Jaro','Edo','Asimovian']
var font_align = [45,42,42.64,45,50,42,42.64,57.69,46.51,50.1]
var font_sizes = [100,100]
var font_align_top = [23.53,11.53,15.79,21.42,23.53,11.53,15.79,21.42,21.74,27.5];
var font_sizes = [100,100];

var pattern_url = "//cdn.shopify.com/s/files/1/0416/3169/t/28/assets/";

var is_new = [1,1,1,0,0,0,0,0,0,0,0,0,0,0,0];
var ass_url = "//cdn.shopify.com/s/files/1/0416/3169/t/28/assets/";
var singlets = ['CHASE','FARGO','HALO','EVOLUTION','CENTURION','KABEL','PERCEPTOR','INSIDER','GLACIER','ZENTRUM','COSMOS','ZUGO','TRANSFORMER','CHEVRON','SHIRES','MEISTER','HARDT','DWINELLE'];
var scolors = ['white#FFFFFF','black#000000','titanium#53575a','cool grey#898a8d',
               'navy#0a2240','royal#0033a1','mars red#ce0e2d','electric blue#0099dc','electric green#74af0d','cardinal#8a2432'];

var phpurl = "";
var picker;
var space = 7;	

var curthumbpage = 0;
var maxthumbpage = 0;

var curpattpage = 0;
var maxpattpage = 0;

var currdesign ;
var currcoltab = 0;
var initcolors = [
	['000000','000000'],
	['8dc6e8','8dc6e8'],
	['e5e1e6','e5e1e6'],
	["000000","000000"],
	["ffffff","ffffff"],
	["ffffff","ffffff"],
	"000000","000000",
	["ffffff","ffffff"]]
var currcolors;


var logholders = ['TEAM_LOGO', 'TEAM_LOGO_PANT','TEAM_NAME_-_JERSEY','TEAM_NAME_-_PANT'];
				
var currlogos=[1,0,0,0];
var teamname ;
var swatches = [0,0,0,0,0,0,0,0,0];

var patterns = ['jungla','tisse','wavy','ecke','furore','graft','depot','pacific','trinity','halle','swift','armour','constructo','lightning','prism','hyper','shards','swish']

var currpattern = -1;
var currpatype = [0,0];
var currside = [0,0,0,0];
var currpatpart = 0;

var font_sizes = [34,51];
var font_id = 0;
var team_name = "TEAM NAME";
var currpart = "jersey";
var curr_fit = "tapered-fit";
var curr_hood = "h-no";
var part_index;
let fs_on = false;
let grad_slider;

function isOverflowed(element){
    return $(element).children('div').innerWidth() >  $(element).innerWidth();
}

function onPageResize(){
	var ww  = $('#uniform-wrapper').parent().innerWidth()
	
	if(ww<=1024){
		sc = ww/1024
	}else{
		sc = 1
	}
	resizeBuilder(sc)
}

function resizeBuilder(sc){

  if(fs_on==false) {
    $('#uniform-wrapper').css({
		'transform-origin':'50% 0%',
		'-webkit-transform-origin':'50% 0%',
		'-moz-transform-origin':'50% 0%',
		'-o-transform-origin':'50% 0%',
		'-ms-transform-origin':'50% 0%',
		'transform':'scale('+sc+')',	
		'-webkit-transform':'scale('+sc+')',	
		'-moz-transform':'scale('+sc+')',	
		'-o-transform':'scale('+sc+')',	
		'-ms-transform':'scale('+sc+')',
        'top': '0px'
    });
	
    $('#uniform-wrapper').parent().css({'overflow':'hidden','height':720*sc});

    
  } else {
    
        $('#uniform-wrapper').css({
            'transform':'scale('+sc+')',
            '-webkit-transform':'scale('+sc+')',
            '-moz-transform':'scale('+sc+')',
            '-o-transform':'scale('+sc+')',
            '-ms-transform':'scale('+sc+')',
            'top': 'calc(50% - 380px)'
 
        });

      $('#uniform-wrapper').parent().css({'overflow':'hidden','height':'100%', 'background':'white'});
      
    }

     $('#footer-wrapper').css({'margin-bottom':'-52px'});
    //$('#page').css({'margin-bottom':'-30px'})
}
				
function initSinglets(){
  
    $(window).bind('resize',onPageResize)
    setTimeout(onPageResize, 500);


    // check fullscreen mode
    
    if(screenfull.isEnabled==true) {
  
        screenfull.on('change', function() {
  
            fs_on = screenfull.isFullscreen ?true:false;
            if(fs_on==false) {
                $('.wu-fs-btn').removeClass('on');
            }
  
  
        });
  
    } else {
  
        // if device doesnt support fullscreen mode
    }

   $('.wu-fs-btn').click(function() {

     if(!$(this).hasClass('on')){
          
         screenfull.request($('#uniform-wrapper').parent()[0]);
         $('.wu-fs-btn').addClass('on');

      } else {
         screenfull.exit();
         setTimeout(onPageResize, 500);
      }

  });
	
  
    //$('.price-curr').bind('click',onCurrencyChange)
	
	$('#req-date').Zebra_DatePicker({direction:true, format:"m.d.Y",onSelect:onDateSelect,onClear:onDateClear});
	comboBox(fontlist,$('#font-select'))	
	
	// $('#team-input, #q-team').bind('keyup',onTeamInput);
    $('#team-input').on('input',onTeamInput);
	$('#q-qty').bind('keyup',calculatePrice)
	
	
	/****************************************/
	
    
    $('#q-file').change(function (){
		var fsplit = $('#q-file').val().split("\\")
		var fname = fsplit[fsplit.length -1].length>0?"":"TEAM LOGO UPLOAD";
		$('#atbtn').text(fname.toString());
      	$('#atbtn').addClass('file-checked');
	})
    
	addPatThumbs()
	initQuoteForm()
	picker = $.farbtastic('#picker');
	picker.linkTo(setColorByPicker)
	$('#color').on('input',onColorInput)
	$('#swatch-btn').bind('click',addToSwatches)
    
    $('.namelogchoose').bind('click',onNameChooseClick)
	$('.teamlogchoose').bind('click',onLogChooseClick)
    $('.namepantlogchoose').bind('click',onNamePantChooseClick)
	$('.teampantlogchoose').bind('click',onLogPantChooseClick)
    
	$('.fitchoose').bind('click',onFitChoose)
    $('.hoodchoose').bind('click',onHoodChoose)
	$('.share-new-btn:not(:has(input))').bind('click',shareDesign)
	$('.tooltipster-icon').tooltipster({touchDevices:true,animation:'grow',speed:150,distance:3});
  
  	$('.pat-part').click(function() {
      	$('.pat-part').removeClass('selected');
      	$(this).addClass('selected');
  		currpatpart = $(this).index();
      	$('.sidechoose').removeClass('pattern-selected');
      	$('.sidechoose').removeClass('pattern-selected');
      	if(currside[2*currpatpart + 0] == 1) $('.sidechoose').eq(0).addClass('pattern-selected');
      	if(currside[2*currpatpart + 1] == 1) $('.sidechoose').eq(1).addClass('pattern-selected');
        $('.patternchoose').removeClass('pattern-selected');
      	$('.patternchoose').eq(currpatype[currpatpart]).addClass('pattern-selected');
      
  	})
	
	$('.patternchoose').bind('click',function(){
		setPatternType($(this).index())
	})
	
	$('.sidechoose').bind('click',function(){
		setPatternSide($(this).index())
	})
	
	$('#team-text').focusin(function(){
		if($('#team-text').val()=='*Separate your teammates emails with a comma'){
			$('#team-text').val('')	
		}	
	})
	$('#team-text').focusout(function(){
		if($('#team-text').val()==''){
			$('#team-text').val('*Separate your teammates emails with a comma')	
		}	
	})
	
	$('#q-text').focusin(function(){
		if($('#q-text').val()=='COMMENTS'){
			$('#q-text').val('')	
		}	
	})
	
	$('#q-text').focusout(function(){
		if($('#q-text').val()==''){
			$('#q-text').val('COMMENTS')	
		}	
	})
	
	var swatch_coockies = getCookies('swatches')==undefined?swatches:getCookies('swatches').split('-').slice(0, 9)
	swatches = swatch_coockies;
	removeLogos()
	
	var query = window.location.href.indexOf('#')!=-1?window.location.href.split('#')[1]:window.location.href.split('=')[1]
	
	if(query==undefined || query==''){
		currdesign = 0
		currcolors = initcolors 
        currlogos = [1,0,0,0]
		teamname = ""
		currpattern = -1
		currpatype = [0,0]
		currside = [1,1,0,0]
		font_id = 0
		team_name = "TEAM NAME"
        curr_fit = "tapered-fit"
        curr_hood = "h-no"
	}else{
		dparts = query.split('/')
		currdesign = dparts[0]
        
		currcolors = initcolors
		var s_col= dparts[1].split('_')
        
		for(i=0;i<s_col.length;i++){

			if(i<6 || i==8){
				currcolors[i] = s_col[i].split('-')
			 }
			 else
			 {
				 currcolors[i] = s_col[i]
			 }
	    }
		
		
        currlogos = dparts[2].split('-')
        
		teamname = dparts[3]
		currpattern = dparts[4]
		currpatype = dparts[5].split('-')
		currside = dparts[6].split('-')
		font_id = dparts[7]?dparts[7]:6
		team_name = dparts[8]?decodeURIComponent(dparts[8]):"TEAM NAME"
        curr_fit = dparts[9]
        curr_hood = dparts[11]

	}
	
  $("#hoodie-wrapper").svg({loadURL: "//www.turn-gymnastics.com/cdn/shop/t/28/assets/WarmUps-Hoodie.svg?12345&v=152865186555827073721755271979",onLoad:function(){
  
     $("#design").svg({loadURL: "//www.turn-gymnastics.com/cdn/shop/t/28/assets/WarmUps.svg?12345789&v=139569689556022688351775716992",onLoad:function(){

		 initNewGradientStyle();

         addThumbs()

         currpart = "jersey"
         currcoltab = 0
         setColor('col1','#'+currcolors[0][0])
         currcoltab = 1
         setColor('col2','#'+currcolors[1][0])
         currcoltab = 2
         setColor('col3','#'+currcolors[2][0])
         currcoltab = 3
         setColor('col4','#'+currcolors[3][0])

         currpart = "pants"
         currcoltab = 0
         setColor('col1','#'+currcolors[0][1])
         currcoltab = 1
         setColor('col2','#'+currcolors[1][1])
         currcoltab = 2
         setColor('col3','#'+currcolors[2][1])
         currcoltab = 3
         setColor('col4','#'+currcolors[3][1])                       

         currpart = "jersey"
         currcoltab = 4
         setColor('col5','#'+currcolors[4][0])
         currcoltab = 5
         setColor('col6','#'+currcolors[5][0])

         currpart = "pants"
         currcoltab = 4
         setColor('col5','#'+currcolors[4][1])
         currcoltab = 5
         setColor('col6','#'+currcolors[5][1])
                       
         currpart = "jersey"
         currcoltab = 6
         setColor('col7','#'+currcolors[6])               
         currcoltab = 7
         setColor('col8','#'+currcolors[7])              

         currpart = "jersey"
         currcoltab = 0
         setLogos()
         addStockColors()
         addSwatches()
         setLogosOnLoad()


         setTeamFont(font_id)
         setTeamName(team_name)
         setFitChoose(curr_fit)
         setHoodChoose(curr_hood)

         $('.pattern-fill').attr('fill','url(#pat-loaded)');                      
  		 $('.pat-part').eq(1).click();
  		 $('.pat-part').eq(0).click();
         if(currpattern !=-1){
            setPattern(currpattern)
        }
  
  		  setColTab($('#j-0'));	  
			 
      }
      });

     }
  });

	
	
	gotoTab(0);
    
	$('#menu div').bind('click',tabClick)
	$('#colours li').bind('click',colTabClick)
	$('#name-colours li').bind('click',colTabClick)
	$('.th-nav-btn').bind('click',thNavClick)
	

	$('#hider').animate({opacity:0},700,function(){$('#hider').css('display','none')})

     createManipulationUI();       
            
}

/****************************************/
/******** add pattern thumbs ************/
/****************************************/
function addPatThumbs(){
	$(patterns).each(function(index,element){
				
		var pt = '<div class="pat-thumb"><img src="'+pattern_url+element+'.jpg" /><div class="pat-thumb-title">'+element.toUpperCase()+'</div></div>'
		$(pt).appendTo('#pat-holder')
        var tx = (Math.floor(index/3))*(103+space)
		var ty = index*(162-space*3) - Math.floor(index/3)*(162-space*3)*3;
		
		$('#pat-holder .pat-thumb:eq('+index+')').css({'left':tx,'top':ty})
        
        var thnew = '<img style="height:32px; width:45px; margin-top:30px; left:20px;" src="//www.turn-gymnastics.com/cdn/shop/t/28/assets/new.png?v=155953233748053933311745397165" />'
        
		// add nwe badge to some of the thumbs
        if (index==0 || index==1 || index==2){
			$(thnew).appendTo($('#pat-holder .pat-thumb:eq('+index+')'))
		}

	})
	
	$('.pat-thumb').bind('click',onPatternSelect)
}

function onPatternSelect(){
	setPattern($(this).index())
}

/****************************************/
/********* menu functions **************/
/****************************************/

function tabClick(){
	var id = $(this).index()
	gotoTab(id)
}

function gotoTab(id){
	var ctab = $('#menu div:eq('+id+')');
	$('#menu div').removeClass('active');
	$(ctab).addClass('active');
	$('#slide-content').stop();
	$('#slide-content').animate({left:-id*322},700);

	if(id==3) {
		$('#sw-st-cont').insertAfter('#name-colours').addClass('grad-scwatch');
		$('#name-colours ul li:first').trigger('click');
	}
	
	if(id==1) {
		$('#sw-st-cont').insertBefore('#col-picker').removeClass('grad-scwatch');
		$('#colours ul li:first').trigger('click');

	}
}


/****************************************/
/********* thumb functions **************/
/****************************************/

function addThumbs(){
  
	var pagecount = Math.floor(singlets.length/6)
	maxthumbpage = pagecount==singlets.length/6?pagecount-1:pagecount
	
	if (pagecount>0){
		$('#page-count').show()
	}else{
		$('#page-count').hide()
	}
	
	$('#page-count').text((curthumbpage+1)+'/'+(maxthumbpage+1))
	
	if(singlets.length>6){
		$('#th-right').show()
	}
  
   // pattern pages
	
	var pattpagecount = Math.floor(patterns.length/9)
    maxpattpage = pattpagecount==patterns.length/9?pattpagecount-1:pattpagecount
	
	if (pattpagecount>0){
		$('#pat-page-count').show()
	}else{
		$('#pat-page-count').hide()
	}
	
	$('#pat-page-count').text((curpattpage+1)+'/'+(maxpattpage+1))
	
	if(patterns.length>9){
		$('#pat-right').show()
	}
	
	$(singlets).each(function(index, element) {
		
		
		var thname = ass_url+'th-'+singlets[index].toLowerCase()+'.png?'+new Date().getTime()
       
        var thsample = '<div class="thumb"><img src="'+thname+'" /><div class="thumb-title">'+singlets[index]+'</div></div>'
		$(thsample).appendTo($('#thumbs-holder'))
		var tx = index*(103+space) - Math.floor(index/3)*(103+space)*3 + Math.floor(index/6)*(103+space)*3
		var ty = Math.floor(index/3)*(162-space) - Math.floor(index/6)*(162-space)*2;
		$('#thumbs-holder .thumb:eq('+index+')').css({'left':tx,'top':ty})
		$('#thumbs-holder .thumb:eq('+index+')').bind('click',thumbClick)
		
		if (is_new[index]==1){
			var thnew = '<img style="height:32px; width:45px; margin-top:35px;" src="//www.turn-gymnastics.com/cdn/shop/t/28/assets/new.png?v=155953233748053933311745397165" />'
			$(thnew).appendTo($('#thumbs-holder .thumb:eq('+index+')'))
		}
    });
	
	loadDesign(currdesign)
	if(currdesign>5){
		navigateToPage('th-right')
	}
}

function thumbClick(){
	var id = $(this).index()
	loadDesign(id)
}

function loadDesign(id){
	$('#design-title').text(singlets[id])
	$('#design').find('*[id*="warmup"]').css('display','none')
	var cdesign = $(document).find('*[id*="'+singlets[id]+'"]')
	$(cdesign).css('display','inline')
	$('#thumbs-holder .thumb-title').removeClass('thumb-title-selected')
	$('#thumbs-holder .thumb-title:eq('+id+')').addClass('thumb-title-selected')
	currdesign = id;
  
    if(curr_fit == "standard") {
      $('#design').find('*[id*="'+singlets[currdesign]+'_warmup_tapered"]').hide();
    }
  
   // if($(cdesign).find('*[id*="col4"]').length==0) {
   //  	$('#j-3, #p-3').addClass('btn-disabled');
   // } else {
   // 		$('#j-3, #p-3').removeClass('btn-disabled');
   // }

   	// remove sleeves from centurion design
	$('#j-sleeve').show();
	if(singlets[currdesign]=='CENTURION') $('#j-sleeve').hide();
	
	$('#svg-file').val(encodeURIComponent($('#design').html()))
}

function thNavClick(){
	navigateToPage($(this).attr('id'))
}

function navigateToPage(dir){
	if(dir=='th-right'||dir=='th-left'){
		if(dir=='th-right'){
			$('#th-left').show()
			curthumbpage++
			if(curthumbpage>maxthumbpage-1){
				$('#th-right').hide()
			}
		}else{
			$('#th-right').show()
			curthumbpage--
			if(curthumbpage==0){
				$('#th-left').hide()
			}
		}
		$('#thumbs-holder').animate({left:-curthumbpage*(322+space)},{duration:400,
		
		 /********* remove flickering ***********/
			step:function(){
				$('#thumbs').hide();
				$('#thumbs').show(.0001)
			}
		})
		
		$('#page-count').text((curthumbpage+1)+'/'+(maxthumbpage+1))
	}
	
	if(dir=='pat-right'||dir=='pat-left'){
		if(dir=='pat-right'){
			$('#pat-left').show()
			curpattpage++
			if(curpattpage>maxpattpage-1){
				$('#pat-right').hide()
			}
		}else{
			$('#pat-right').show()
			curpattpage--
			if(curpattpage==0){
				$('#pat-left').hide()
			}
		}
		$('#pat-holder').animate({left:-curpattpage*(322+space)},{duration:400,
		
		 /********* remove flickering ***********/
			step:function(){
				$('#patterns').hide();
				$('#patterns').show(.0001)
			}
		})
		
		$('#pat-page-count').text((curpattpage+1)+'/'+(maxpattpage+1))
	}
	
}


/****************************************/
/********* color functions **************/
/****************************************/

function addStockColors(){
	var rows = 1
	var space = 1
	$(scolors).each(function(index, element) {
		var cname = element.split('#')[0].toUpperCase()
		var cval = '#'+element.split('#')[1]
        var csample = '<div class="swatch tooltip" title="'+cname+'" style="background-color:'+cval+'"></div>'
		$(csample).appendTo($('#stock'))
		//var tx = (Math.floor(index/rows))*(22+space)
		//var ty = index*(22+space) - Math.floor(index/rows)*(22+space)*rows;
		//$('#stock .swatch:eq('+index+')').css({'left':tx,'top':ty,'background-color':cval})
        $('#stock .swatch:eq('+index+')').css({'background-color':cval})
		$('#stock .swatch:eq('+index+')').bind('click',swatchClick)
    });
}

function addSwatches(){
	var rows = 1
	var space = 1
	$(swatches).each(function(index, element) {
		var cval = element==0?'#fff':'#'+element
		var cname = element==0?'empty':cval;
		var xval = element==0?'x':''
	    var csample = '<div class="swatch tooltip" title="'+cname+'" style="background-color:'+cval+'">'+xval+'</div>'
		$(csample).appendTo($('#swatch'))
		var tx = (Math.floor(index/rows))*(22+space)
		var ty = index*(22+space) - Math.floor(index/rows)*(22+space)*rows;
		//$('#swatch .swatch:eq('+index+')').css({'left':tx,'top':ty,'background-color':cval})
        $('#swatch .swatch:eq('+index+')').css({'background-color':cval})
		$('#swatch .swatch:eq('+index+')').bind('click',swatchClick)
	});
	$('.tooltip').tooltipster({touchDevices:false,animation:'grow',speed:150,distance:3});
}



function colTabClick(){
  if(!$(this).hasClass('btn-disabled')) {
  	setColTab($(this))
  }	
}

function setColTab(ctab){
	
	currcoltab = Number($(ctab).attr('id').split('-')[1])
	currpart = $(ctab).parent().parent().attr('class').split('-')[0]
	part_index = currpart=="jersey"?0:1 
		
	if(currcoltab!=7 || currcoltab!=7){
		$('#col-picker, #swatch-btn, #swatch, #swatch-label, #colsamp, #color').show()
	}else{
		$('#col-picker, #swatch-btn, #swatch, #swatch-label, #colsamp, #color').hide()
	}
  
  	if(range==null) {
      initGradientPicker();
    }
  
    let colselected = currcolors[currcoltab][part_index];
  
  	if(currcoltab!=8){
		isgradient = false
        $('#gradient-picker').hide()
		$('.grad-color').removeClass('grad-focus');
		$('#col-picker').removeClass('gradpick');	
	}else{
		
		$('#gradient-picker').show();
		$('#col-picker').addClass('gradpick');

		$('#grad-check').removeClass('grad-check-selected');
		isgradient = false;
		colselected = grad_color[part_index][0].slice(1);

		if(grad_color[part_index][3]==1){
			isgradient = false;
			$('#grad-check').addClass('grad-check-selected');
		}
		
	}
	
	$('#colours ul li').removeClass('menu-selected');
	$('#name-colours ul li').removeClass('menu-selected');
	$(ctab).addClass('menu-selected');

	console.log(colselected);
	picker.setColor('#'+colselected);
  
  	// hide swatch colors for zipper
	if(currcoltab==7) {
		$('#stock .swatch:eq(3), #stock .swatch:eq(5)').hide();
	} else {
		$('#stock .swatch').show();
	}

}


function swatchClick(){
	part_index = currpart=="jersey"?0:1
	 
	var swcolor = $(this).css('background-color')
	/**** if swatch empty do not chnage color *****/
    
    if($(this).tooltipster('content')!='empty'){
		if(isgradient==false){
			picker.setColor(RGBtoHEX(swcolor));
			setColor(currcoltab+1,swcolor)
		}else{
			$('#colsamp').css('background-color',swcolor)
			picker.setColor(RGBtoHEX(swcolor));
		}
	}
	
}

function setColorByPicker(){
  
	var pcolor = picker.color
	$('#color').val(pcolor)
	
	if(isgradient==false){
		
		currcolors[currcoltab][part_index]  = pcolor.split('#')[1]
        
        if(Array.isArray(currcolors[currcoltab])==false) {
        	currcolors[currcoltab] = pcolor.split('#')[1]
        }
        
		setColor('col'+(currcoltab+1),pcolor);
			
	}else{
		
		onGradPicker();
	}
}


function setColor(part,value){
  
    //for gradients
    // let pc = $(part).attr('class')
    // $('.'+pc+'grad').attr('fill',value);
  
	
	let cpart = $(document).find('*[id*="'+part+'-'+currpart+'"]')

    // set color for parts using gradient 
  
    let gpart = $(document).find('*[id*="'+part+'grad-'+currpart+'"]')

   if(gpart!=undefined && gpart.length>0) {
     
      let coltype = gpart.attr('id').indexOf('grad');

      if(coltype!=-1) {

        $(gpart).each(function(j, gp) {

          $(gp).find('*').each(function(i, e) {
            let furl = $(e).attr('fill');
            furl = furl.replace('url(','').replace(')','');
            $(furl).find('stop').attr('stop-color',value);
          })
  
  
          let furl = $(gp).attr('fill');
          furl = furl.replace('url(','').replace(')','');
          $(furl).find('stop').attr('stop-color',value);
          
        })                
        // fill gradient types
      }
    }
    
    $(cpart).find('*').not('[fill*="url"]').attr('fill',value)
	$(cpart).attr('fill',value)
    $(cpart).css('color',value) 
 
	$('#colsamp').css('background-color',value)
	
	//$('#svg-file').val(encodeURIComponent($('#design').html()))
}

function RGBtoHEX (color) {
  return "#"+$.map(color.match(/\b(\d+)\b/g),function(digit){
    return ('0' + parseInt(digit).toString(16)).slice(-2)
  }).join('');
};

function onColorInput(){
	var ival = $(this).val().split('#')
	var tval = ival.join('')
	$(this).val('#'+tval)
	picker.setColor($(this).val());
}

function addToSwatches(){
	var scolor = picker.color
	$('#swatch .tooltip').tooltipster('destroy');
	
	var duplicate=false
	$(swatches).each(function(sindex, selement) {
		if(scolor.split('#')[1] == selement){
			duplicate=true
			return false;
		}
	})
	if(duplicate==false){
	$(swatches).each(function(index, element) {
		if(element==0){
			swatches[index] = scolor.split('#')[1]
			$('#swatch .swatch:eq('+index+')').css('background-color',scolor)
			$('#swatch .swatch:eq('+index+')').text('')
			$('#swatch .swatch:eq('+index+')').attr('title',scolor)
			setCookies()
			return false;
		}
		if(index==9 && element!=0){
			swatches.splice(0,1)
			swatches.push(scolor.split('#')[1])
			replaceSwatches()
		}
	});
	}
	
	
	$('#swatch .tooltip').tooltipster({touchDevices:false,animation:'grow',speed:150,distance:3});
}

function replaceSwatches(){
	$(swatches).each(function(index, element) {
		$('#swatch .swatch:eq('+index+')').css('background-color','#'+swatches[index])
		$('#swatch .swatch:eq('+index+')').attr('title','#'+swatches[index])
    });
	$('#swatch .tooltip').tooltipster({
      touchDevices:false,animation:'grow',speed:150,distance:3});
	setCookies()
}

function setCookies(){
	document.cookie='swatches='+swatches.join('-');
}

function getCookies(name){
  var value = "; " + document.cookie;
  var parts = value.split("; " + name + "=");
  if (parts.length == 2) return parts.pop().split(";").shift();
}


/****************************************/
/*************** logo functions *********/
/****************************************/

function onLogChooseClick(){
	var id = $(this).index()
	setLogChooseStat($(this).attr('id'))
}

function setLogChooseStat(id){
	var tgt = $('#'+id)
	$('.teamlogchoose').removeClass('logo-selected')
	$(tgt).addClass('logo-selected')
	if(id=='no'){
		currlogos[0]=0
	}else{
		currlogos[0]=1
	}
	setLogos()
}


function onLogPantChooseClick(){
	var id = $(this).index()
	setLogPantChooseStat($(this).attr('id'))
}

function setLogPantChooseStat(id){
	var tgt = $('#'+id)
	$('.teampantlogchoose').removeClass('logo-selected')
	$(tgt).addClass('logo-selected')
	if(id=='p-no'){
		currlogos[1]=0
	}else{
		currlogos[1]=1
	}
	setLogos()
}

function onNameChooseClick() {
	var id = $(this).index()
	setNameChooseStat($(this).attr('id'))
}

function setNameChooseStat(id){
	var tgt = $('#'+id)
	$('.namelogchoose').removeClass('logo-selected')
	$(tgt).addClass('logo-selected')
	if(id=='n-no'){
		currlogos[2]=0
	}else{
		currlogos[2]=1
	}
	setLogos()
}

function onNamePantChooseClick() {
	var id = $(this).index()
	setNamePantChooseStat($(this).attr('id'))
}

function setNamePantChooseStat(id){
	var tgt = $('#'+id)
	$('.namepantlogchoose').removeClass('logo-selected')
	$(tgt).addClass('logo-selected')
	if(id=='np-no'){
		currlogos[3]=0
	}else{
		currlogos[3]=1
	}
	setLogos()
}

function onFitChoose(){

	setFitChoose($(this).attr('id'))
}

function setFitChoose(id){

  	curr_fit = id
	var tgt = $('#'+id)
    
	$('.fitchoose').removeClass('fit-logo-selected')
    
	$(tgt).addClass('fit-logo-selected')
    
    if (curr_fit=='standard-fit') {
		$('#design [id*="col1-pants"]').parent().attr('clip-path','url(#col1-clip-st_1_)')
        $('#design [id*="col2-pants"]').parent().attr('clip-path','url(#col1-clip-st_1_)')
        $('#design [id*="col3-pants"]').parent().attr('clip-path','url(#col1-clip-st_1_)')
        $('#design [id*="col4-pants"]').parent().attr('clip-path','url(#col1-clip-st_1_)')
     	$('#mask-tapered, .mask-tapered').hide()
    } else {
       $('#design [id*="col1-pants"]').parent().attr('clip-path','url(#col1-clip-tp_1_)')
       $('#design [id*="col2-pants"]').parent().attr('clip-path','url(#col1-clip-st_1_)')
       $('#design [id*="col3-pants"]').parent().attr('clip-path','url(#col1-clip-st_1_)')
       $('#design [id*="col4-pants"]').parent().attr('clip-path','url(#col1-clip-st_1_)')
       $('#mask-tapered, .mask-tapered').show()
     }
}


function onHoodChoose() {
  setHoodChoose($(this).attr('id'))
}

function setHoodChoose(id) {
   $('#hoodie-wrapper').show();
    curr_hood = id;
	var tgt = $('#'+id)
    $('.hoodchoose').removeClass('hood-selected');
    $(tgt).addClass('hood-selected');

  $('.ntype').hide();
  
    if(curr_hood=="h-yes") {
      $('#hoodie-wrapper #hoodie').show();
    } 

   if(curr_hood=="h-up") {
      $('#hoodie-wrapper #standup').show();
    }

   if(curr_hood=="h-no") {
      $('#hoodie-wrapper #standard').show();
    }
	
	calculatePrice()
}


function removeLogos(){
	$(logholders).each(function(index, element) {
		if(index==0){
			$(element).each(function(tindex, telement) {
               $('.'+telement).css('opacity',0)
            });
		}else{
            var tgt = element.indexOf('TEAM_NAME')==-1?$('.'+element):$('#'+element)
        	$(tgt).css('opacity',0)
		}
    });
}

function setLogosOnLoad(){
  
	
	if(currlogos[0]==1){
		$('#yes').click()
    } else {
    	$('#no').click()
    }
  
  	if(currlogos[1]==1){
      	$('#p-yes').click()
    } else {
    	$('#p-no').click()
    }
	
	if(currlogos[2]==1){
      	$('#n-yes').click()
    } else {
    	$('#n-no').click()
    }
	
  
  	if(currlogos[3]==1){
      	$('#np-yes').click()
    } else {
    	$('#np-no').click()
    }
  
  
	$('#svg-file').val(encodeURIComponent($('#design').html()))

}



function setLogos(){
	
	removeLogos()
	
	$(currlogos).each(function(index, element) {
      	setLogo(logholders[index],element)
    });
	
	$('#svg-file').val(encodeURIComponent($('#design').html()))
}


function setLogo(target,value){
	var tgt = target.indexOf('TEAM_NAME')==-1?$('.'+target):$('#'+target)
	
	if(value==1){
		$(tgt).css('opacity',1)
	}else{
		$(tgt).css('opacity',0)
	}
}


/********************************************/
/************ share functions ***************/
/********************************************/

let succ_int = null;

function shareDesign(){
  
	const platform = $(this).attr('id');
	const tgtbtn = $(this);
	let share_url = getDesignUrl();
	let body_content = "Check out our brand new uniform:<br><br>"+share_url;
	let team_mails = [];
	let team_count = 0;

	// footer is added directly in AAA form builder

	$('#share-form #share-msg').html(body_content);

	if(platform=='sembtn') {
		$('#share-form #replyemail').val($('#self-mail').val());
	} else {
		team_mails = $('#team-text').val().replaceAll(/\s/g,'').split(',');
		$('#share-form #replyemail').val(team_mails[team_count]);
	}


	// disable form temporary
	$('#overview').css({
		'opacity':0.7,
		'pointer-events': 'none'
	})
	
	$(tgtbtn).find('.share-new-btn-text').text('SENDING');

	succ_int = setInterval(() => {

		let succ_msg = $('#share-form .success').text();

		if(succ_msg=='success') {

			// if single email sent

			if(platform=='sembtn') {

				console.log('Message sent !');
				clearInterval(succ_int);
				// reset success message
				$('#share-form .success').text('');
				$(tgtbtn).find('.share-new-btn-text').text('SENT');
				$(tgtbtn).find('.share-new-btn-icon').addClass('sent');

				setTimeout(()=> {
					$('#overview').css({
						'opacity':1,
						'pointer-events': 'all'
					})
					$(tgtbtn).find('.share-new-btn-text').text('SEND NOW');
					$(tgtbtn).find('.share-new-btn-icon').removeClass('sent');
				}, 2000);

			} else {
				// if team email sent
				
				if(team_count==team_mails.length-1) {
					clearInterval(succ_int);
					// reset success message
					$('#share-form .success').text('');
					$(tgtbtn).find('.share-new-btn-text').text('SENT');
					$(tgtbtn).find('.share-new-btn-icon').addClass('sent');

					setTimeout(()=> {
						$('#overview').css({
							'opacity':1,
							'pointer-events': 'all'
						})
						$(tgtbtn).find('.share-new-btn-text').text('SEND NOW');
						$(tgtbtn).find('.share-new-btn-icon').removeClass('sent');
					}, 2000);
				} else {
					team_count++;
					$('#share-form .success').text('');
					$('#share-form #replyemail').val(team_mails[team_count]);
					setTimeout(()=> {
							$('#share-sub').trigger('click');
					}, 200)
				}				
			}
		}
	}, 30);

	setTimeout(()=> {
			$('#share-sub').trigger('click');
	}, 200)
}



function getDesignUrl(){

	var color_data = currcolors.join('_').split(',').join('-')
	var share_url = "https://www.turn-gymnastics.com/pages/custom-kit-builder-warmups/?design="
	share_url += currdesign+'/'+ color_data +'/'+currlogos.join('-')+'/'+teamname+'/'+currpattern+'/'+currpatype.join('-')+'/'+currside.join('-') +'/'+font_id +'/'+escape(team_name) +'/'+curr_fit+'/'+ctr_vals[0].join('_') + '_' + ctr_vals[1].join('_') + '_' + ctr_vals[2].join('_') + '_' + ctr_vals[3].join('_') + '/' + curr_hood;

	return share_url
}

function setPatternSide(pid){
	if ($('.sidechoose:eq('+(pid-2)+')').hasClass('pattern-selected'))
	{		
		$('.sidechoose:eq('+(pid-2)+')').removeClass('pattern-selected')
		currside[pid-2+2*currpatpart] = 0
	}
	else
	{
		currside[pid-2+2*currpatpart] = 1
		$('.sidechoose:eq('+(pid-2)+')').addClass('pattern-selected')
	}
	
	if(currpattern !=-1){
		setPattern(currpattern)
	}
}

function setPatternType(pid){

	currpatype[currpatpart] = pid;

	$('.patternchoose').removeClass('pattern-selected')
	$('.patternchoose:eq('+pid+')').addClass('pattern-selected')
	
	if(currpattern !=-1){
		setPattern(currpattern)
	}

}

function setPattern(pid){
  
	//$('[id*=pattern-fill]').attr('fill','url()');
    $('[id*=pattern-fill]').attr('fill','rgba(0,0,0,0)');
	
	currpattern = pid
	curpatimg = patterns[currpattern]
	$('.pat-thumb-title').removeClass('pat-thumb-title-selected')
	$('.pat-thumb-title:eq('+pid+')').addClass('pat-thumb-title-selected')
	if(currpatype[currpatpart] != -1){
		
		$('#patdefs').empty()
		
		$('.pattern-fill').attr('fill','url()')
        
        
        // resize armour pattern
        if(pid!=0){
			createPattern('','pat-loaded-j',149,61,230,241,currpatype[0])
			createPattern('-back','pat-loaded-j-back',394,61,230,241,currpatype[0])
        } else {
        	createPattern('','pat-loaded-j',116,61,300,311,currpatype[0])
			createPattern('-back','pat-loaded-j-back',62,61,300,311,currpatype[0])
        }
        
        createPattern('','pat-loaded-p',149,307,230,284,currpatype[1])
		createPattern('-back','pat-loaded-p-back',394,307,230,284,currpatype[1])
		
		$(currside).each(function(index, element) {
			if(element==1 && index==0){
				$('#pattern-fill-front-j').attr('fill','url(#pat-loaded-j)')
			}
			if(element==1 && index==1){
				$('#pattern-fill-back-j').attr('fill','url(#pat-loaded-j-back)')
			}
            if(element==1 && index==2){
                  $('#pattern-fill-front-p').attr('fill','url(#pat-loaded-p)')
             }
             if(element==1 && index==3){
                  $('#pattern-fill-back-p').attr('fill','url(#pat-loaded-p-back)')
             }
        });	
	}
}

function createPattern(pside,pid,x,y,w,h,pt){
	var patsample = document.createElementNS('http://www.w3.org/2000/svg','pattern');
	patsample.setAttribute('id',pid)
	patsample.setAttribute('patternUnits','userSpaceOnUse')
	patsample.setAttribute('x',x)
	patsample.setAttribute('y',y)
	patsample.setAttribute('width',w)
	patsample.setAttribute('height',h)
	
	var patloaded = document.createElementNS('http://www.w3.org/2000/svg','image');
	var shade = pt==0?'light':'dark'
	patloaded.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href',pattern_url+curpatimg+'-'+shade+pside+'.png?'+new Date().getTime())
	patloaded.setAttribute('x',0)
	patloaded.setAttribute('y',0)
	patloaded.setAttribute('width',w)
	patloaded.setAttribute('height',h)
	$(patloaded).appendTo($(patsample))
	$(patsample).appendTo($('#patdefs'))
}


// gradient picker

var isgradient=false
var grad_a_pct = 0
var grad_b_pct = 1
var grad_tgt = null
var grad_color = [['#444444',0,100,0],['#444444',0,100,0]]
var first_update = 0
var range = null;

function initGradientPicker(){
	
	
	$('#grad-top, #grad-bot').bind('click',onGradColorClick)
	$('#grad-check').bind('click',onGradCheck)
	
	$('#grad-color').bind('click',function(){
		$('.grad-color').removeClass('grad-focus')
		grad_tgt=$('#grad-top')
		$(grad_tgt).addClass('grad-focus')
		setGradientColor()
	})
	
	range = document.getElementById('grad-pct');
	
	var top_val = 0;
	var bot_val = 1;
  
	grad_slider = noUiSlider.create(range, {
		start: [ top_val, bot_val ],
		margin: 0, 
		connect: true,
		direction: 'ltr',
		orientation: 'vertical',
		behaviour: 'tap-drag',
		step: 0.01,
		tooltips: false,
		range: {
			'min': 0,
			'max': 1
		}
	});
	
	
	range.noUiSlider.on('update', function( values, handle ) {
		
		grad_a_pct = values[0]
		grad_color[part_index][1] = Math.floor(grad_a_pct*100)
		grad_b_pct = values[1]
		grad_color[part_index][2] = Math.floor(grad_b_pct*100)
		
		$('.grad-color').removeClass('grad-focus');
		grad_tgt = handle==0?$('#grad-top'):$('#grad-bot');
		$(grad_tgt).addClass('grad-focus');
		setGradientColor()
		
		var samp_id = handle==0?0:2
		$('#colsamp').css('background-color',grad_color[part_index][0])
		$('#color').val(grad_color[part_index][0])
		
		if(isgradient==true){
			//picker.setColor(grad_color[part_index][samp_id]);
		}
			
	})
    
    
    for(i=1; i>=0; i--) {
      
      part_index = i;
	
      if(currcolors[8][part_index].indexOf('.')!=-1){

           var colsplit = currcolors[8][part_index].split('.')
           grad_color[part_index][0] = '#'+colsplit[0]
           grad_color[part_index][1] = colsplit[1]
           grad_color[part_index][2] = colsplit[2]

           top_val = grad_color[part_index][1]/100
           bot_val = grad_color[part_index][2]/100
           $('#grad-top').css('background-color',grad_color[part_index][0])
		   $('#grad-bot').css('background-color',grad_color[part_index][0])
           
           isgradient=true
		   $('#grad-check').addClass('grad-check-selected');
		   $('#grad-bot').addClass('grad-focus');
           if(part_index==1) {setColTab('#p-0')} else {setColTab('#j-0')}  ;
           range.noUiSlider.set([grad_color[part_index][1]/100,grad_color[part_index][2]/100]);
      } else {
      	   isgradient=false
           $('.grad-color').removeClass('grad-focus');
      }
      
      first_update = 3;
      $('#colsamp').css('background-color','#'+currcolors[8][part_index]);
	  $('#color').val('#'+currcolors[8][part_index]);
      
    }
	
	
	if(isgradient==false){
		$('.grad-color').removeClass('grad-focus')
	}
	
}

function onGradCheck(){
		
	if(isgradient==false){

		grad_color[part_index][3] = 1;

		isgradient=true;
		$(this).addClass('grad-check-selected');
		setGradientColor();
		$('.new-grad-'+part_index).show();

	}else{

		grad_color[part_index][3] = 0;

		isgradient=false;
		$(this).removeClass('grad-check-selected');
		//$('.new-grad-'+part_index).attr('fill','transparent');
		$('.new-grad-'+part_index).hide();
	}
}


// deprecated

function onGradColorClick(){
	
	isgradient=true
	
	$('.grad-color').removeClass('grad-focus')
	$(this).addClass('grad-focus')
	
	grad_tgt=$(this)
	if($(this).attr('id')=="grad-top"){
		picker.setColor(grad_color[part_index][0]);
		$('#colsamp').css('background-color',grad_color[part_index][0])
	}else{
		picker.setColor(grad_color[part_index][2]);
		$('#colsamp').css('background-color',grad_color[part_index][1])
	}
	
	setGradientColor()
}

function onGradPicker(){

	grad_color[part_index][0] = picker.color;
	$('#colsamp').css('background-color',picker.color)
	setGradientColor();
}


function setGradientColor(){
		
	updateGradSample();
	setNewGradColor();
	return;
    
    $('#grad-top').css('background-color',grad_color[part_index][0])
	$('#grad-bot').css('background-color',grad_color[part_index][2])
	
	first_update ++
    if(first_update>2){
		isgradient=true
		$('#grad-check').addClass('grad-check-selected')
		$('#grad-check').attr("checked", "checked")
        var grad = '#body-gradient-'+ part_index
		$(grad+' stop:eq(0)').attr('stop-color',grad_color[part_index][0])
		$(grad+' stop:eq(1)').attr('stop-color',grad_color[part_index][2])
		$(grad).attr('y1',grad_color[part_index][1]/100)
		$(grad).attr('y2',grad_color[part_index][3]/100)
        
        
        var cpart = part_index==0?$(document).find('*[id*="col1-'+currpart+'-grad"]'):$(document).find('*[id*="col1-'+currpart+'"]') 
        var spart = $(document).find('*[id*="col1-'+currpart+'"]') // sleeve
        
        $(spart).attr('fill',grad_color[part_index][0])
		$(spart).find('path,rect,polygon,polyline').not('[class*="pattern-fill"]').attr('fill',grad_color[part_index][0])
		        
		
		$(cpart).attr('fill','url('+grad+')')
		$(cpart).find('path,rect,polygon,polyline').not('[class*="pattern-fill"]').attr('fill','url('+grad+')')		       
        
		currcolors[currcoltab][part_index] = grad_color[part_index].join('.').split('#').join('')
		first_update = 2
	}
}


/*
<defs id="grad-def">
  <linearGradient id="body-gradient-0" x1="0.5" y1="0" x2="0.5" y2="1">
   <stop offset="0" stop-color="#ff0000" />
   <stop offset="1" stop-color="#ccff00" />
  </linearGradient>
  <linearGradient id="body-gradient-1" x1="0.5" y1="0" x2="0.5" y2="1">
   <stop offset="0" stop-color="#ff0000" />
   <stop offset="1" stop-color="#ccff00" />
  </linearGradient>
  
  <path id="col1-clip-st" fill="none" d="M219.504,313.022c0,0,28.332,0.259,46.241,0.259c14.776,0,49.444,0.526,49.444,0.526
			l0.224,8.664c0,0,1.58,5.982,3.268,13.687c3.971,18.118,1.31,73.098,2.429,127.331c1.246,60.401,3.296,117.678,3.297,117.678
			c0,0-7.901,1.968-18.874,2.359c-11.403,0.408-23.703-0.788-23.703-0.788s-4.164-119.743-8.34-141.252
			c-3.867-19.933-3.071-43.213-6.669-43.704c-3.822-0.521-1.485,18.917-5.95,42.435c-4.938,26.021-8.01,142.127-8.01,142.127
			s-13.167,0.791-24.29,0.474c-9.955-0.283-19.603-2.259-19.603-2.259s2.9-60.339,4.111-121.392
			c1.061-53.529-1.039-97.431,1.904-122.047c0.976-8.166,3.796-14.651,3.796-14.651L219.504,313.022z M463.279,313.022
			c0,0,28.331,0.259,46.24,0.259c14.776,0,49.444,0.526,49.444,0.526l0.223,8.664c0,0,1.581,5.982,3.27,13.687
			c3.967,18.118,1.308,73.098,2.427,127.331c1.247,60.401,3.298,117.678,3.298,117.678s-7.902,1.968-18.875,2.359
			c-11.402,0.408-23.7-0.788-23.7-0.788s-4.166-119.743-8.34-141.252c-3.867-19.933-3.073-43.213-6.672-43.704
			c-3.82-0.521-1.484,18.917-5.948,42.435c-4.938,26.021-8.01,142.127-8.01,142.127s-13.17,0.791-24.29,0.474
			c-9.955-0.283-19.602-2.259-19.602-2.259s2.9-60.339,4.109-121.392c1.061-53.529-1.036-97.431,1.903-122.047
			c0.978-8.166,3.797-14.651,3.797-14.651L463.279,313.022z"/>
	
	<clipPath id="col1-clip-st_1_">
		<use xlink:href="#col1-clip-st"  overflow="visible"/>
	</clipPath>
</defs> 

<defs id="patdefs"></defs>
*/


// new gradient style /////////////////////////////////

function initNewGradientStyle() {


	// remove old grad samples
	$('#grad-top').remove();
	$('#grad-bot').remove();
	$('#grad-color').css( {
		'margin-top': '11px',
		'height': '145px'
	})

	let flipper = $('<label>FLIP<input id="grad-flip" type="checkbox" style="position: relative; top: 1px; opacity:0"></label>"');
	flipper.insertAfter('#grad-pct');
	flipper.css({
		'position': 'absolute',
		'right': '-1px',
		'bottom': '-29px',
		'font-size': '16px',
		'cursor': 'pointer'
	})

	$('#grad-flip').on('change', flipGradient);


	// add new gradient container for jersey

	grad = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
	grad.setAttribute('x', 149);
	grad.setAttribute('y', 61);
	grad.setAttribute('width', 480);
	grad.setAttribute('height', 245);
	grad.classList.add('new-grad-0');
	//grad.setAttribute('fill', 'url(#body-gradient)');
	grad.setAttribute('fill', 'transparent');
	$(grad).insertAfter('#design #pattern-clips');


	// add new gradient container for pants

	grad = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
	grad.setAttribute('x', 149);
	grad.setAttribute('y', 307);
	grad.setAttribute('width', 480);
	grad.setAttribute('height', 285);
	grad.classList.add('new-grad-1');
	//grad.setAttribute('fill', 'url(#body-gradient)');
	grad.setAttribute('fill', 'transparent');
	$(grad).insertAfter('#design #pattern-clips');


}

function hexToRgbA(hex,a){
    var c;
    if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
        c= hex.substring(1).split('');
        if(c.length== 3){
            c= [c[0], c[0], c[1], c[1], c[2], c[2]];
        }
        c= '0x'+c.join('');
        return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+a+')';
    }
    throw new Error('Bad Hex');
}

function updateGradSample() {

	let colrgba =  hexToRgbA(grad_color[part_index][0],0);

	$('#grad-color').css(
		{
			'background': '-webkit-linear-gradient(top,  '+grad_color[part_index][0]+' '+grad_color[part_index][1]+'%,'+colrgba+' '+grad_color[part_index][2]+'%)',
			'background': '-o-linear-gradient(top,  '+grad_color[part_index][0]+' '+grad_color[part_index][1]+'%,'+colrgba+' '+grad_color[part_index][2]+'%)',
			'background': '-moz-linear-gradient(top,  '+grad_color[part_index][0]+' '+grad_color[part_index][1]+'%,'+colrgba+' '+grad_color[part_index][2]+'%)',
			'background': 'linear-gradient(to bottom, '+grad_color[part_index][0]+' '+grad_color[part_index][1]+'%,'+colrgba+' '+grad_color[part_index][2]+'%)'
		}
	)
}

function setNewGradColor() {

	first_update ++
    if(first_update>2){

		let colrgba = hexToRgbA(grad_color[part_index][0],0);

		isgradient=true;
		$('#grad-check').addClass('grad-check-selected');
		$('#grad-check').attr("checked", "checked");
        var grad = '#body-gradient-'+ part_index;

		if(grad_flip[part_index]==true) {

			$(grad+' stop:eq(0)').attr('stop-color',colrgba);
			$(grad+' stop:eq(1)').attr('stop-color',grad_color[part_index][0]);
		} else {
			$(grad+' stop:eq(0)').attr('stop-color',grad_color[part_index][0]);
			$(grad+' stop:eq(1)').attr('stop-color',colrgba);
		}
		
		$(grad).attr('y1',grad_color[part_index][1]/100);
		$(grad).attr('y2',grad_color[part_index][2]/100);
        
		$('.new-grad-'+part_index).attr('fill','url('+grad+')');
        
		currcolors[currcoltab][part_index] = grad_color[part_index].join('.').split('#').join('')
		first_update = 2
	}
}

let grad_flip = [false, false];


function flipGradient() {

	console.log('clicked');

	grad_flip[part_index] = $('#grad-flip').prop('checked');

	grad_tmp = 100-grad_color[part_index][2];
	grad_color[part_index][2] = 100-grad_color[part_index][1];
	grad_color[part_index][1] = grad_tmp;
	grad_slider.set([grad_color[part_index][1]/100,grad_color[part_index][2]/100]);

	setNewGradColor();
}